function getCallsUrlBase () {
  if (process.env.VUE_APP_NODE_ENV === 'development') return 'https://callstest.keybe.bio/'
  if (process.env.VUE_APP_NODE_ENV === 'local_development') return 'http://localhost:3101/'
  if (process.env.VUE_APP_NODE_ENV === 'test') return 'https://callstest.keybe.bio/'
  return 'https://calls.cloudtask.com/'
}

function getKeybeUrlBase () {
  if (process.env.VUE_APP_NODE_ENV === 'development') return 'https://admintest.keybe.bio/'
  if (process.env.VUE_APP_NODE_ENV === 'local_development') return 'http://localhost:3101/'
  if (process.env.VUE_APP_NODE_ENV === 'test') return 'https://admintest.keybe.bio/'
  return 'https://admin.cloudtask.com/'
}

function getSequencesUrlBase () {
  if (process.env.VUE_APP_NODE_ENV === 'development') return 'https://sequencestest.keybe.bio/'
  if (process.env.VUE_APP_NODE_ENV === 'local_development') return 'http://localhost:3101/'
  if (process.env.VUE_APP_NODE_ENV === 'test') return 'https://sequencestest.keybe.bio/'
  return 'https://sequences.cloudtask.com/'
}

function getOAuthUrlBase () {
  // TODO add test url
  return 'https://goauth.cloudtask.com/'
}

const CallsUrlBase = getCallsUrlBase()
const OAuthUrlBase = getOAuthUrlBase()
const UrlBase = getKeybeUrlBase()
const SequencesUrlBase = getSequencesUrlBase()
export { CallsUrlBase, OAuthUrlBase, SequencesUrlBase, UrlBase }
